import React from 'react';
import { translate } from '../utlis/translations/i18n';
import { Tooltip, Button, Navbar, NavbarGroup, Alignment, NavbarHeading, NavbarDivider, Menu, MenuItem, MenuDivider, Popover, Position } from "@blueprintjs/core";
import { Link, withRouter } from "react-router-dom";

import Auth from "../services/Auth";

class Header extends React.Component {

    state = {
        isAdmin: false
    }

    handleMenuItem_LogOut = () => {
        const { history } = this.props;

        return (history.push('/logout'));
    }
    handleMinimalMenuItem_Discover = () => {
        window.location = 'https//www.visualsense.com';
    }
    handleMinimalMenuItem_MyAccount = () => {
        const { history } = this.props;

        return (history.push('/'));
    }

    componentDidMount() {
        if (Auth.getUserId() === 'S86sotaTDUN9yS5IsgB5ngrIoj72') {
            this.setState({ isAdmin: true })
        }
    }

    render() {
        const { minimal } = this.props;
        const { isAdmin } = this.state
        const headerMinimalMenu = (
            <Menu>
                <MenuDivider title="VisualSense" />
                <MenuItem
                    text="Découvrir VisualSense.fr"
                    icon="home"
                    onClick={this.handleMinimalMenuItem_Discover} />
                <MenuItem
                    text="Mon compte"
                    icon="user"
                    onClick={this.handleMinimalMenuItem_MyAccount} />
            </Menu>
        );

        if (minimal)
            return (
                <Popover
                    content={headerMinimalMenu}
                    position={Position.BOTTOM_LEFT}>
                    <Button
                        icon="menu"
                        minimal={true}
                        large={true} />
                </Popover>
            );

        const userMenu = (
            <Menu>
                <MenuDivider title={Auth.getUser().firstname + " " + Auth.getUser().lastname} />
                <MenuItem icon="log-out" text="Logout" onClick={this.handleMenuItem_LogOut} />
            </Menu>
        )


        return (
            <Navbar>
                <NavbarGroup align={Alignment.LEFT}>
                    <NavbarHeading>VisualSense</NavbarHeading>
                    <NavbarDivider />
                    <a href="https://www.visualsense.fr" className="bp3-button bp3-minimal bp3-icon-home">{translate('home.backTo')} VisualSense.fr</a>
                </NavbarGroup>
                <NavbarGroup align={Alignment.RIGHT}>
                    {isAdmin && (
                        <Link to="/users"><Button icon="user" minimal={true}>{translate('users')}</Button></Link>
                    )}
                    <Link to="/"><Button icon="projects" minimal={true}>{translate("sessions")}</Button></Link>
                    <Tooltip
                        content="Create session">
                        <Link to="/create"><Button icon="plus" minimal={true}></Button></Link>
                    </Tooltip>
                    {Auth.isAuth() &&
                        <Popover content={userMenu} position={Position.BOTTOM}>
                            <Button minimal={true} icon="user" />
                        </Popover>}
                    {!Auth.isAuth() && <Link to="/login" className="bp3-button bp3-minimal bp3-icon-log-in">{translate('login')}</Link>}
                </NavbarGroup>
            </Navbar>
        );
    }
}

export default withRouter(Header);
